bam-infographic-facts {
// ############################################### //
// ------------------ Defaults ------------------- //
// ############################################### //
  bam-page-section {
    margin-bottom: 2px;
  }

  .bam-infographic-facts__rise-section {
    @include desktop {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    bal-heading {
      margin-bottom: 3rem;

      @include desktop {
        margin-bottom: 0;
        // flex: 1 1 auto
      }
    }

    @include desktop {
      align-items: center;
    }

    .bam-infographic-facts__rise-wrapper {
      margin-top: 2.5rem;

      @include tablet {
        margin-top: 2rem;
        align-items: flex-end;
      }

      @include desktop {
        margin-top: 0;
        align-items: flex-end;
        flex-wrap: nowrap;
        flex: 0 1 auto;
      }

      .bam-infographic-facts__rise-group {
        margin-bottom: 20px;
        display: inline-flex;
        align-items: baseline;

        @include tablet {
          margin-bottom: 0;
        }

        @include desktop {
          flex: 0 0 auto;
        }

        p {
          margin-bottom: 0 !important;

          &:first-child {
            margin-right: 1rem
          }
        }

        .bam-infographic-facts__rise-group-value {
          font-size: 3rem;
          line-height: 3rem;
          margin-right: 1rem;

          @include tablet {
            font-size: 5rem;
            line-height: 5rem;
          }
        }
      }

    }
  }

  .bam-infographic-facts__progression {
    display: flex;
    align-items: center;
    margin-top: 1.5rem;

    @include tablet {
      margin-top: 0;
      margin-bottom: 1rem;
    }

    @include desktop {
      flex: 0 1 auto;
      margin-left: 5rem;
    }

    bal-icon {
      margin-right: 0.5rem;
    }

    &.is-up {
      bal-icon {
        & svg,
        g,
        path,
        circle {
          fill: var(--bal-color-success-5);
        }
      }
    }

    &.is-stable {
      bal-icon {
        & svg,
        g,
        path,
        circle {
          fill: var(--bal-color-warning-5);
        }
      }
    }

    &.is-down {
      bal-icon {
        & svg,
        g,
        path,
        circle {
          fill: var(--bal-color-danger-5);
        }
      }
    }
  }

// ############################################### //
// ---------------- Chart Version ---------------- //
// ############################################### //
  &.bam-infographic-facts--is-chart {
    .bam-infographic-facts__content {
      display: flex;
      flex-direction: column;

      @include desktop {
        flex-direction: row;
      }

      .bam-infographic-facts__item-header {
        order: 1;

        @include desktop {
          order: 2;
        }
      }

      .bam-chart {
        order: 2;

        @include desktop {
          order: 1;
          padding-right: 1rem;
        }
      }

      .bam-infographic-facts__item-content {
        order: 3;
      }

      .bam-infographic-facts__item-header,
      .bam-infographic-facts__item-content {
        @include tablet {
          display: block;
          opacity: 1;
          transition: opacity .3s ease-in-out .2s;

          &.is-hidden-content {
            display: none;
            transition: opacity .3s ease-in-out;
            opacity: 0;
          }
        }
      }

    }
  }

// ############################################### //
// --------------- Figures Version --------------- //
// ############################################### //
  &.bam-infographic-facts--is-figures {

    .bam-infographic-facts__summary {
      padding-bottom: .5rem;

      p {

        &:not(:last-child) {
          margin-bottom: 2rem;
        }

        @include tablet {
          font-size: 2rem;

          &:not(:last-child) {
            margin-bottom: 3rem
          }
        }

        @include desktop {
          &:not(:last-child) {
            margin-bottom: 0;
          }
        }

        span {
          display: block;
          font-size: 1rem;
          margin-top: .5rem;

          @include tablet {
            display: inline;
            margin-left: 1rem;

            &:not(.is-small) {
              font-size: 1.5rem;
            }
          }
        }
      }

      @include desktop {
        display: flex;

        & > p:not(:last-child) {
          margin-right: 8rem;
        }
      }
    }
  }

// ############################################### //
// ----------- Figures Default Version ----------- //
// ############################################### //
  &.bam-infographic-facts--is-figures-default {
    .bam-infographic-facts__header {
      bal-heading {
        margin-top: 0.5rem;
        margin-bottom: 1rem;

        @include desktop {
          margin-top: 0;
          margin-bottom: 0;
        }
      }
      @include tablet {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
    }

    .bam-infographic-facts__shareholder-section {
      bal-heading {
        margin-bottom: 2.5rem;

        @include desktop {
          margin-bottom: 1rem;
        }
      }

      @include desktop {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }

    .bam-infographic-facts__shareholder-calculation{
      display: flex;
      flex-direction: column;
      align-items: center;

      @include tablet {
        flex-direction: row;
        margin-bottom: 2.5rem;
      }

      @include desktop {
        margin-bottom: 1rem;
      }

      .bam-infographic-facts__shareholder-value {
        width: 100%;
        background-color: var(--bal-color-grey-1);
        border-radius: 8px;
        padding: 1rem;
        text-align: center;

        @include tablet {
          width: auto;
          display: flex;
          flex-direction: column;
        }

        p {
          font-size: 1.25rem;

          @include tablet {
            font-size: 1.5rem;
          }

          &.small {
            line-height: 1.25rem;
            font-size: var(--bal-space-small);

            span {
              font-size: 0.75rem;
              line-height: 1rem;
            }
          }

          @include tablet {
            text-align: left;

            &:not(.small) {
              span {
                font-size: 1.5rem;
              }
            }
          }
        }

        &:last-child {
          margin-bottom: 2.5rem;

          @include tablet {
            margin-bottom: 0;
          }
        }

        @include tablet {
          background-color: transparent;
          border-radius: 0;
          padding: 0;
        }
      }

      span {
        margin: 1rem 0;
        font-size: 1.25rem;
        line-height: 1.5rem;

        @include tablet {
          margin: 0 1rem;
        }
      }
    }

    .bam-infographic-facts__rise-shareholder {
      .bam-infographic-facts__rise-shareholder-value {
        font-size: 48px;
        margin: 0 1rem;
      }
    }
  }
}
